// extracted by mini-css-extract-plugin
module.exports = {"MoreButton":"MoreButton_MoreButton__2SDtP"};